import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Cpu } from 'lucide-react';
import aiAgentService from '../services/aiAgentService';

export default function AIAgentEngineStatus({ lightSurface = false, className = '' }) {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.shared.aiAgent.engineStatus.${key}`, opts);
  const [status, setStatus] = useState(() => aiAgentService.getEngineStatus());

  useEffect(() => {
    aiAgentService.refreshEngineStatus().then(setStatus);
    const onEvent = (event, data) => {
      if (event === 'engine_status') setStatus(data);
    };
    aiAgentService.addListener(onEvent);
    const interval = setInterval(() => {
      aiAgentService.refreshEngineStatus().then(setStatus);
    }, 30000);
    return () => {
      aiAgentService.removeListener(onEvent);
      clearInterval(interval);
    };
  }, []);

  const label =
    status.engine === 'hermes'
      ? p('hermes')
      : status.engine === 'cloud-fallback'
        ? p('cloud_fallback')
        : status.engine === 'cloud'
          ? p('cloud')
          : p('hermes_offline');

  const tone =
    status.hermesAvailable || status.engine === 'cloud'
      ? lightSurface
        ? 'text-emerald-700 bg-emerald-50 border-emerald-200'
        : 'text-emerald-300 bg-emerald-500/10 border-emerald-400/30'
      : lightSurface
        ? 'text-amber-800 bg-amber-50 border-amber-200'
        : 'text-amber-200 bg-amber-500/10 border-amber-400/30';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide ${tone} ${className}`}
      title={p('title', { label })}
    >
      <Cpu className="h-3 w-3" />
      {label}
    </span>
  );
}
